import { customRangeFormat } from "@similarweb/pro-logic-components";

import { swSettings } from "app/common/services/swSettings";
import { normalizeKeyword } from "app/pages/keyword-research/keyword-analysis/common-components/KeywordAnalysisModuleFrame";
import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { BasicDurations } from "app/services/DurationService";

export const onRedirectKeywordGeneratorTool: transitionHookFn = (transition) => {
    const toParams = transition.params("to");
    const searchTerm = transition.params().keyword;
    const normalized = normalizeKeyword(searchTerm);

    const minDate = swSettings.components.KeywordsGeneratorV2?.startDate;
    const maxWindowDate = swSettings.components.KeywordsGeneratorV2?.windowEndDate;
    const startDateString = `${minDate.format(customRangeFormat)}`;
    const endDateString = `${maxWindowDate.format(customRangeFormat)}`;
    const allTimeDuration = `${startDateString}-${endDateString}`;

    let didChangeParams = false;
    const finalParams = { ...toParams };
    if (toParams.duration !== BasicDurations.LAST_TWENTY_EIGHT_DAYS && toParams.duration !== allTimeDuration) {
        didChangeParams = true;
        finalParams.duration = allTimeDuration;
    }
    if (searchTerm && normalized && normalized !== searchTerm) {
        didChangeParams = true;
        finalParams.keyword = normalized;
    }
    if (didChangeParams) {
        return { params: finalParams };
    }
};
